<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DÉTAIL DU' : (Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN") }} PRODUCTEUR</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />

        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2" v-if="!detail__detail">

                <p class="mt-5" >Nom <b style="color: #ff6141">*</b> </p>
                <vs-input 
                  :disabled="detail__detail"
                  :danger="error.last_name || all_errors.last_name.length ? true : false"
                  v-model="input.last_name" class="w-full" name="item-code" />
                <span v-if="error.last_name || all_errors.last_name.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.last_name" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>
                
                <p class="mt-5" >Prénoms <b style="color: #ff6141">*</b> </p>
                <vs-input 
                  :disabled="detail__detail"
                  :danger="error.first_name || all_errors.first_name.length ? true : false"
                  v-model="input.first_name" class="w-full" name="item-code" />
                <span v-if="error.first_name || all_errors.first_name.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.first_name" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Code <b style="color: #ff6141">*</b> </p>
                <vs-input 
                  :disabled="detail__detail"
                  :danger="error.code || all_errors.code.length ? true : false"
                  v-model="input.code" class="w-full" name="item-code" />
                <span v-if="error.code || all_errors.code.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.code" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>

                <p class="mt-5" >Numéro de téléphone <b style="color: #ff6141">*</b> </p>
                <vs-input 
                  :disabled="detail__detail"
                  :danger="error.phoneNumber || all_errors.phoneNumber.length ? true : false"
                  v-model="input.phoneNumber" class="w-full" name="item-code" />
                <span v-if="error.phoneNumber || all_errors.phoneNumber.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.phoneNumber" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>
                

                <p class="mt-5" >Coopérative <b style="color: #ff6141">*</b> </p>
                <v-select :disabled="detail__detail" multiple
                  :reduce="rep => rep.id" class="w-full" label="name" v-model="input.cooperatives" :options="cooperativess"></v-select>
                <span v-if="error.cooperatives || all_errors.cooperatives.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.cooperatives" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>


            </div>

            <vs-list v-if="detail__detail">
              <vs-list-header icon-pack="feather" icon="icon-users" title="Information"></vs-list-header>
              
              <!-- <vs-list-item icon-pack="feather" icon="icon-check" :title="input.code" subtitle="Code"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" :title="input.last_name" subtitle="Nom"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" :title="input.first_name" subtitle="Prénoms"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" :title="input.phoneNumber" subtitle="Numéro de téléphone"></vs-list-item> -->

              <vs-list-item icon-pack="feather" icon="icon-check" title="Code" :subtitle="input.code"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Nom" :subtitle="input.last_name"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Prénoms" :subtitle="input.first_name"></vs-list-item>
              <vs-list-item icon-pack="feather" icon="icon-check" title="Numéro de téléphone" :subtitle="input.phoneNumber"></vs-list-item>



              <vs-list-header icon-pack="feather" icon="icon-globe" title="Coopératives" color="success"></vs-list-header>
              <vs-list-item v-for="(cooperative, ioj) in input.cooperatives" :key="ioj" icon-pack="feather" icon="icon-shield" :title="cooperative.name" :subtitle="'Coopérative ' + (ioj + 1)"></vs-list-item>
            </vs-list>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    var base_self;
    var input_tempon = {
      id: null,
      last_name: '',
      first_name: '',
      phoneNumber: '',
      code: '',
      cooperatives: [],
      picture: '',
      proof: ''
    };

    import 'swiper/dist/css/swiper.min.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar, swiper, swiperSlide},
        props: {
            isSidebarActive: {
              type: Boolean,
              required: true
            },
            data: {
              type: Object,
              default: () => {},
            },
        },
        data() {
            return {
                swiperOption: {
                  spaceBetween: 30,
                  centeredSlides: true,
                  autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                  },
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                  }
                },
                cooperativess: [],
                dataImg: [],
                dataImg_file: [],
                dataImg1: [],
                dataImg1_delete: [],
                dataImg1_file: [],
                initialNoError: {
                  last_name: false,
                  cooperatives: false,
                  first_name: false,
                  phoneNumber: false,
                  code: false,
                },
                error: {
                  last_name: false,
                  cooperatives: false,
                  first_name: false,
                  phoneNumber: false,
                  code: false,
                },
                all_errors: {
                  last_name: [],
                  cooperatives: [],
                  first_name: [],
                  phoneNumber: [],
                  code: [],
                },
                input: JSON.parse(JSON.stringify(input_tempon)),
                input1: JSON.parse(JSON.stringify(input_tempon)),
                detail__detail: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                      this.$emit('closeSidebar')
                    }
                }
            },
            isFormValid() {
              var is_valide = true;
              if (!this.input.last_name || this.input.last_name === '') is_valide = false;
              if (!this.input.first_name || this.input.first_name === '') is_valide = false;
              if (!this.input.phoneNumber || this.input.phoneNumber === '') is_valide = false;
              if (!this.input.code || this.input.code === '') is_valide = false;
              if (!base_self.input.cooperatives || base_self.input.cooperatives.length === 0) is_valide = false;
              return is_valide;
            }
        },
        methods: {
          async delete_carte_identite(data) {
            if (data.id) {
              base_self.dataImg1_delete.push(data.id);
              base_self.input.producerPictures.splice(data.key, 1);
            } else {
              base_self.dataImg1.splice(data.key, 1);
            }
            /* this.$vs.dialog({
              type:'confirm',
              color: 'danger',
              title: 'Confirmation',
              text: 'Confirmer la suppression?',
              acceptText: 'Confirmer',
              cancelText: 'Annuler',
              accept: async () => {
                if (data.id) {
                  base_self.dataImg1_delete.push(data.id);
                  base_self.input.producerPictures.splice(data.key, 1);
                } else {
                  base_self.dataImg1.splice(data.key, 1);
                }
              }
            }) */
          },
          async getCooperatives () {
            let reponse = await base_self.$store.state.cooperatives({})
            base_self.cooperativess = reponse.data.results
          },
          verification_name () {
            let libelle = 'Le nom est réquis.';
            if (!base_self.initialNoError.last_name) return false;
            if (base_self.input.last_name.length === 0) {
              base_self.all_errors.last_name.push(libelle)
            } else {
              base_self.all_errors.last_name = base_self.all_errors.last_name.filter(e => e !== libelle);
            }
          },
          verification_cooperatives () {
            let libelle = 'Les coopératives sont réquises.';
            if (!base_self.initialNoError.cooperatives) return false;
            if (!base_self.input.cooperatives || base_self.input.cooperatives.length === 0) {
              base_self.all_errors.cooperatives.push(libelle)
            } else {
              base_self.all_errors.cooperatives = base_self.all_errors.cooperatives.filter(e => e !== libelle);
            }
          },
          verification_first_name () {
            let libelle = 'Les prénoms sont réquis.';
            if (!base_self.initialNoError.first_name) return false;
            if (base_self.input.first_name.length === 0) {
              base_self.all_errors.first_name.push(libelle)
            } else {
              base_self.all_errors.first_name = base_self.all_errors.first_name.filter(e => e !== libelle);
            }
          },
          verification_phoneNumber () {
            let libelle = 'Le numéro de téléphone est réquis.';
            if (!base_self.initialNoError.phoneNumber) return false;
            if (base_self.input.phoneNumber.length === 0) {
              base_self.all_errors.phoneNumber.push(libelle)
            } else {
              base_self.all_errors.phoneNumber = base_self.all_errors.phoneNumber.filter(e => e !== libelle);
            }
          },
          verification_code () {
            let libelle = 'Le code du producteur est réquis.';
            if (!base_self.initialNoError.code) return false;
            if (base_self.input.code.length === 0) {
              base_self.all_errors.code.push(libelle)
            } else {
              base_self.all_errors.code = base_self.all_errors.code.filter(e => e !== libelle);
            }
          },
          async submitData() {
              base_self.$vs.loading()
              var input = JSON.parse(JSON.stringify(this.input));
              var form = new FormData()

              const keys = ['last_name', 'first_name', 'phoneNumber', 'code'];
              var length = keys.length;
              var iuoy = 0;
              for (iuoy = 0; iuoy < length; iuoy++) {
                var item = keys[iuoy];
                form.append(item, input[item]);
              }

              for (iuoy = 0; iuoy < input.cooperatives.length; iuoy++) {
                form.append('cooperatives', input.cooperatives[iuoy]);
              }

              console.log('input: ', input);
              
              if(!input.id) {     
                  base_self.$store.state.producer_post(form)
                    .then((response) => { 
                      base_self.all_errors = {
                        last_name: [],
                        cooperatives: [],
                        first_name: [],
                        phoneNumber: [],
                        code: []
                      };
                
                      window.getAgroTrack.success('Le producteur est ajouté avec succès.', response);
                      window.getAppProducers.getProducers();
                      this.$emit('closeSidebar');
                      this.initValues()
                      base_self.$vs.loading.close()
                    })
                    .catch((error) => { 
                      // console.log('error: ', error)
                      if (error.response.data.code) {
                        base_self.all_errors.code = ['Un producteur avec ce champ code existe déjà.']
                      }
                      
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                      base_self.$vs.loading.close()
                    });
                
              } else if (input.id) {
                  base_self.$store.state.producer_update(form, input.id)
                    .then((response) => { 
                      base_self.all_errors = {
                        last_name: [],
                        cooperatives: [],
                        first_name: [],
                        phoneNumber: [],
                        code: []
                      };
                
                      window.getAgroTrack.success('Le producteur est modifié avec succès.', response);
                      window.getAppProducers.getProducers();
                      this.$emit('closeSidebar');
                      this.initValues()
                      base_self.$vs.loading.close()
                    })
                    .catch((error) => { 
                      if (error.response.data.code) {
                        base_self.all_errors.code = ['Un producteur avec ce champ code existe déjà.']
                      }
                      console.log('error: ', error)
                      base_self.$vs.loading.close()
                    });
              }
          },
          initValues() {
              this.initialNoError = {
                last_name: false,
                cooperatives: false,
                first_name: false,
                phoneNumber: false,
                code: false,
              };
              base_self.input = JSON.parse(JSON.stringify(input_tempon));
              base_self.input1 = JSON.parse(JSON.stringify(input_tempon));
              base_self.detail__detail = false;
              base_self.dataImg = [];
              base_self.dataImg_file = [];
              base_self.dataImg1 = [];
              base_self.dataImg1_delete = [];
              base_self.dataImg1_file = [];
              // window.getProducers.sidebarData.detail__detail = false;
          },
        },
        watch: {
          input: {
            handler () {
              if (base_self.input1.last_name !== base_self.input.last_name) 
              {
                base_self.initialNoError.last_name = true
                base_self.verification_name()
              }

              if (base_self.input1.first_name !== base_self.input.first_name) 
              {
                base_self.initialNoError.first_name = true
                base_self.verification_first_name()
              }

              if (base_self.input1.phoneNumber !== base_self.input.phoneNumber) 
              {
                base_self.initialNoError.phoneNumber = true
                base_self.verification_phoneNumber()
              }

              if (base_self.input1.code !== base_self.input.code) 
              {
                base_self.initialNoError.code = true
                base_self.verification_code()
              }

              if (base_self.input1.cooperatives.length !== base_self.input.cooperatives.length) 
              {
                base_self.initialNoError.cooperatives = true
                base_self.verification_cooperatives()
              }
              base_self.input1 = JSON.parse(JSON.stringify(base_self.input));
            },
            deep: true
          },
          async isSidebarActive() {
              this.initValues();
              if (base_self.data && base_self.data.id) {
                // Object.assign(base_self.input, JSON.parse(JSON.stringify(base_self.data)));
                base_self.input = JSON.parse(JSON.stringify(base_self.data));
              }

              if (base_self.data.detail__detail) {
                base_self.detail__detail = true;
              }
              /* if(window.getAppProducers.sidebarData.id) {
                  let response = await base_self.$store.state.categories_requests_detail({}, window.getAppProducers.sidebarData.id);

                  this.input = JSON.parse(JSON.stringify(response.data));
                  console.log('categories_requests_detail response :    ::::::::::::::::::::::::', response);

                  this.detail__detail = window.getAppProducers.detail__detail;
              } */
          }
        },
        created() {
            window.EditCategory = this;
            base_self = this;
            base_self.initValues()
            base_self.getCooperatives()
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
        
    }
</style>